import { useState, useEffect, useContext } from "react";
import axios from "axios";
import React from "react";
import { toast, ToastContainer } from "react-toastify";

import MyContext from "../../../MyContext";
import POSPrint from "./POS_Print";
import POSPrintKitchen from "./POS_Print_Kitchen";
const keypadFull = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["0", "Clear", "⌫"],
];

const POSOrderType = ({
  tabletMode,
  editCustomer,
  setEditCustomer,
  setOrderId,
  setScreen,
  mobile,
  setMobile,
  setOrderType,
  orderType,
  generateOrderIDApi,
  orders,
  filteredOrders,
  selectedPaymentFilter,
  setSelectedPaymentFilter,
  selectedOrderTypeFilter,
  setSelectedOrderTypeFilter,
  setSelectedCustomer,
  selectedCustomer,
  customerList,
  setCart,
  setSelectedTable,
  selectedTable,
  setTables,
  table,
  setSelectedOrder,
  selectedOrder,
  userID,
  setTotalPrice,
  setSelectedDiscount,
  catalogueStore,
  getCustomerApi,
  fetchTableApi,
  reciptDetails,
  orderId,
  setName,
  gstClaim,
  sgst,
  cgst,
  rooms,
  setSelectedRoom,
  selectedRoom,
  orderOption,
  cancelPOSOrderApi,
  setCancelOrderReason,
  cancelOrderReason,
  setDueAmount,
  setPaidAmount,
  setOrderStatus,
  setSelectedCartItem,
  enrichedTables,
  posOrderLoader,
  searchCustomerLoader,
  getOrdersApi,
  printConfig,
  setAssignToPackkyModal,
  setDeliveryPartner,
}) => {
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [showTableModal, setShowTableModal] = useState(false);
  const [showRoomOrderModal, setShowRoomOrderModal] = useState(false);
  const [showCancelReasonModal, setShowCancelReasonModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showAddressFormFor, setShowAddressFormFor] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [billNumber, setBillNumber] = useState("");
  const [billLoader, setBillLoader] = useState(false);

  const [newAddress, setNewAddress] = useState({
    address: "",
    city: "",
    name: "",
  });

  const [editingName, setEditingName] = useState(false);
  const [newName, setNewName] = useState("");
  const [editingDetails, setEditingDetails] = useState({
    contact_name: selectedCustomer?.contact_name || "",
    billingName: selectedCustomer?.billingName || "",
    billingGst: selectedCustomer?.billingGst || "",
    address: selectedCustomer?.billingAddress || "",
    orderID: selectedCustomer?.orderid || "",
  });
  const [saving, setSaving] = useState(false);

  const [particularOrderDetails, setParticularOrderDetails] = useState({});

  const resetForm = () => {
    setNewAddress({
      name: "",
      address: "",
      city: "",
    });
    setFormErrors({});
  };
  const clearSelectedOrder = () => {
    setSelectedOrder({});
    setOrderId("");
    setMobile("");
    setName("");
    setSelectedCustomer({});
    setSelectedCartItem({});
    setTotalPrice(null);
    setDueAmount(0.0);
    setPaidAmount(0.0);
    setOrderStatus("");
  };
  const clearAllForNewOrder = () => {
    // setSelectedOrder(null);
    // setSelectedCustomer(null);
    clearSelectedOrder();
    fetchTableApi();
    setCart([]);
    setTotalPrice(null);
    setSelectedDiscount(0);
    resetForm();
    // setTables(null);
    setSelectedCartItem({});
    // setSelectedTable("");
    setEditCustomer(false);

    setDueAmount(0.0);
    setPaidAmount(0.0);
    setOrderStatus("");
    setAssignToPackkyModal(false);
    setDeliveryPartner("");
    // setSelectedCustomer(null);
  };
  const clearForEditSettle = () => {
    // setSelectedOrder(null);
    // clearSelectedOrder();
    setSelectedDiscount(0);
    setSelectedCustomer(null);
    setCart([]);
    setTotalPrice(null);
    setTables(null);
    // setSelectedTable("");
    resetForm();
    fetchTableApi();
    setEditCustomer(false);
  };

  const orderDetailesAPI = async (orderid) => {
    try {
      setBillLoader(true);
      const requestBody = { orderid };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosOrderDetails`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00" && response.data.response) {
        setParticularOrderDetails(response.data.response);
        setSelectedOrder(response.data.response);
      } else {
        alert("No Order Found");
      }
    } catch (error) {
      console.error("Error making API call:", error);
      return null;
    } finally {
      setBillLoader(false);
    }
  };

  const handleInputChange = (field, value) => {
    setNewAddress((prev) => ({ ...prev, [field]: value }));

    // Only clear the error if the current field has the top-level error
    if (formErrorsOrder[0] === field) {
      setFormErrors((prev) => {
        const updated = { ...prev };
        delete updated[field];
        return updated;
      });
    }
  };

  const validateFields = (customer = {}, address = {}) => {
    const errors = {};

    // Validate Name
    if (!address.name || !address.name.trim()) {
      errors.name = "Name is required.";
    }

    // Validate Address
    if (!address.address || !address.address.trim()) {
      errors.address = "Address is required.";
    }

    // Validate City
    if (!address.city || !address.city.trim()) {
      errors.city = "City is required.";
    }

    // Validate Mobile Number
    if (!customer.contact_number || !customer.contact_number.trim()) {
      errors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(customer.contact_number)) {
      errors.mobile = "Enter a valid 10-digit mobile number.";
    }

    return errors;
  };

  const formErrorsOrder = ["name", "address", "city", "mobile"];

  const handleAddNewAddress = async (customer) => {
    const errors = validateFields(customer, newAddress);

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    const payload = {
      userid: userID,
      custName: customer.contact_name,
      custMobile: customer.contact_number,
      address: {
        address: newAddress.address,
        landmark_area: newAddress.landmark_area,
        city: newAddress.city,
      },
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/addDeliveryAddress`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setShowAddressFormFor(null);
        setNewAddress({
          name: "",
          address: "",
          landmark_area: "",
          city: "",
          // ...reset other fields
        });
        getCustomerApi();
        setFormErrors({});
      } else {
        setFormErrors({ api: data.responseMessage });
      }
    } catch (err) {
      setFormErrors({ api: "Failed to add address. Please try again." });
    }
  };

  const handleAddMoreAddress = async (customer) => {
    const errors = {};

    // Basic required field validations
    if (!newAddress.address.trim()) {
      errors.address = "Full Address is required.";
    } else if (!newAddress.landmark_area.trim()) {
      errors.landmark_area = "Landmark / Area is required.";
    } else if (!newAddress.city.trim()) {
      errors.city = "City is required.";
    }

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    // Proceed to send to backend
    const payload = {
      userid: userID,
      custName: customer.contact_name,
      custMobile: mobile,
      address: {
        address: newAddress.address,
        landmark_area: newAddress.landmark_area,
        city: newAddress.city,
      },
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/addDeliveryAddress`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setShowAddressFormFor(null);
        setNewAddress({
          address: "",
          landmark_area: "",
          city: "",
        });
        setFormErrors({});
        getCustomerApi();
      } else {
        setFormErrors({ api: data.responseMessage });
      }
    } catch (err) {
      setFormErrors({ api: "Failed to add address. Please try again." });
    }
  };

  const handleDefaultAddress = async (contact_number, address) => {
    //    if (mobile.length !== 10 || mobile.length !== 12) {
    // return;
    //    }
    const payload = {
      userid: userID,
      address: address,
      custMobile: contact_number,
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/setDefaultDeliveryAddress`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        getCustomerApi();
      } else {
        // alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      // alert("Failed to add address");
      console.error("API error:", error);
    }
  };

  const openTablePrompt = () => {
    setMobile("");
    setSelectedTable("");

    setShowTableModal(true);
  };
  const openViewPrompt = () => {
    setShowViewModal(true);
  };

  const openRoomOrderPrompt = () => {
    setMobile("");
    setShowRoomOrderModal(true);
  };
  useEffect(() => {
    if (selectedCustomer && selectedCustomer.address?.length) {
      setSelectedAddressId(selectedCustomer.address[0].id);
    }
  }, [selectedCustomer]);
  const openMobilePrompt = () => {
    setMobile("");
    setCart([]);
    setOrderId("");
    setSelectedOrder({});
    setSelectedCustomer({});
    setShowMobileModal(true);
    setShowAddressFormFor(null);
  };

  const getAllCatalogItems = (catalog) => {
    return catalog.flatMap((category) => category.menu_items || []);
  };

  const onSettleClick = (order) => {
    if (!order?.items || order.items.length === 0) {
      console.warn("No items found in the order.");
      return;
    }

    clearForEditSettle(); // if you use this in open flow too

    const allItems = getAllCatalogItems(catalogueStore);

    const formattedItems = order.items
      .map((orderItem) => {
        const quantity = parseInt(orderItem.quantity || "1", 10);
        const itemId = orderItem.product_id;
        const sizeId = orderItem.size_id;

        const catalogItem = allItems.find((item) => item.item_id === itemId);
        if (!catalogItem) {
          console.warn("Catalog item not found for settle", itemId);
          return null;
        }

        const selectedPrice = catalogItem.prices.find(
          (p) => p.size_id === sizeId
        );
        if (!selectedPrice) {
          console.warn(
            "Size not found for item in settle",
            itemId,
            "size",
            sizeId
          );
          return null;
        }

        return {
          ...catalogItem,
          prices: [selectedPrice], // ✅ only selected size
          selectedPrice,
          quantity,
        };
      })
      .filter(Boolean);

    setCart(formattedItems);
    setMobile(order.customer_mobile.replace("+91", "").trim());
    setOrderId(order.orderid);

    // setSelectedTable(order);
    setOrderType(order.orderType);
    if (order.orderType === "dining") {
      setSelectedTable({
        tableNo: order.table_no || order.tableNo || "",
      });
    }
    setTotalPrice(order.totalOrderPrice);
    setDueAmount(order.due_amount);
    setPaidAmount(order.pay_amount);
    setOrderStatus(order.payment_status);
    setScreen("Payment");
  };

  const onOpenClick = (order) => {
    if (!order?.items?.length) return;

    clearForEditSettle();

    const allItems = getAllCatalogItems(catalogueStore);

    const formattedItems = order.items
      .map((orderItem) => {
        const quantity = parseInt(orderItem.quantity || "1", 10);
        const itemId = orderItem.item_id;
        const sizeId = orderItem.size_id;

        const catalogItem = allItems.find((item) => item.item_id === itemId);
        if (!catalogItem) {
          console.warn("Catalog item not found", itemId);
          return null;
        }

        const selectedPrice = catalogItem.prices.find(
          (p) => p.size_id === sizeId
        );
        if (!selectedPrice) {
          console.warn("Size not found for item", itemId, "size", sizeId);
          return null;
        }

        // ✅ Parse customization from string to array (if exists)
        let customizations = [];
        try {
          if (orderItem.customization) {
            customizations = JSON.parse(orderItem.customization);
          }
        } catch (e) {
          console.error("Failed to parse customization for item", itemId, e);
        }

        //Include KOT-specific fields
        const kot_quatity = parseInt(orderItem.kot_quatity || quantity, 10);
        const kot_quantity_printed = parseInt(
          orderItem.kot_quantity_printed || 0,
          10
        );
        const fullPrinted = !!orderItem.fullPrinted;

        return {
          ...catalogItem,
          prices: [selectedPrice], // single price variant
          quantity, // numeric quantity
          selectedPrice, // price object
          customizations, //  attach parsed customization
          kot_quatity, // KOT quantity
          kot_quantity_printed, //  KOT printed quantity
          fullPrinted, //  whether fully printed
        };
      })
      .filter(Boolean);

    setOrderId(order.orderid);
    setSelectedCartItem({});
    setCart(formattedItems);
    setTotalPrice(order.totalOrderPrice);
    setSelectedTable(order);
    setOrderType(order.orderType);
    if (order.orderType === "dining") {
      setSelectedTable({
        tableNo: order.table_no || order.tableNo || "",
      });
    }
    setMobile(order.customer_mobile.replace("+91", "").trim());
    setSelectedCustomer({
      contact_name: order.customer_name,
      contact_number: order.customer_mobile,
    });
    setScreen("Catalog");
  };

  // const onOpenClick = (order) => {
  //   if (!order?.items || order.items.length === 0) {
  //     console.warn("No items found in the order.");
  //     return;
  //   }
  //     clearForEditSettle();
  //   const formattedItems = order.items.map((item) => ({
  //     productId: item.product_id,
  //     item_id: item.product_id,
  //     item_name: item.item_name || "Unnamed Item",
  //     item_description: "",
  //     discount: "",
  //     dish: ["1"],
  //     photo: "",
  //     item_name_trans: "",
  //     item_description_trans: "",
  //     sub_category: "",
  //     category: ["2246"],
  //     ratings: "0",
  //     prices: [
  //       {
  //         price: item.item_price,
  //         formatted_price: `₹${item.item_price}`,
  //         discount: "",
  //         discount_price: 0,
  //         formatted_discount_price: "₹0.00",
  //         size: "large",
  //         size_id: "3",
  //         size_trans: "",
  //         customizations: [],
  //       },
  //     ],
  //     icon_dish: ["https://chaafo.com/upload/1741168834-vegicon.png"],
  //     position: "",
  //     inStock: true,
  //     homedeliveryAvailability: true,
  //     takeawayAvailability: true,
  //     diningAvailability: true,
  //     quantity: parseInt(item.quantity) || 1,
  //   }));

  //   setCart(formattedItems);
  //   setTotalPrice(order.totalOrderPrice);
  //   setMobile(order.customer_mobile.replace("+91", "").trim());
  //   setScreen("Catalog");
  // };
  const handleKeyClick = (key) => {
    if (key === "Clear") setMobile("");
    else if (key === "⌫") setMobile((prev) => prev.slice(0, -1));
    else if (/^\d$/.test(key) && mobile.length < 10)
      setMobile((prev) => prev + key);
  };

  const handleSubmitMobile = () => {
    if (
      mobile.length === 10 ||
      mobile.length === 12 ||
      orderType === "dining"
    ) {
      setMobile(mobile);
      generateOrderIDApi(mobile, orderType);

      setShowMobileModal(false);
      setScreen("Catalog");
    }
  };
  const handleDefaultSubmit = () => {
    setMobile("9999999999");
    generateOrderIDApi("9999999999", orderType);

    setShowMobileModal(false);
    setScreen("Catalog");

  };
  //  const handleSubmitMobile = () => {
  //     // setMobile(mobile);
  //     generateOrderIDApi(mobile, orderType);

  //     setShowMobileModal(false);
  //     setScreen("Catalog");
  // };

  const handleSubmitTable = ({ item }) => {
    // setSelectedTable(item);
    // console.log("🚀 setSelectedTable called with", item);
    setShowTableModal(false);

    const existingOrder = item.attachedOrder;

    if (
      existingOrder &&
      existingOrder.status?.trim().toLowerCase() === "hold" &&
      Array.isArray(existingOrder.items) &&
      existingOrder.items.length > 0
    ) {
      console.log("✅ RESUMING EXISTING ORDER", existingOrder);

      clearForEditSettle();

      const allItems = getAllCatalogItems(catalogueStore);

      const formattedItems = existingOrder.items
        .map((orderItem) => {
          const quantity = parseInt(orderItem.quantity || "1", 10);
          const itemId = orderItem.product_id;
          const sizeId = orderItem.size_id;

          const catalogItem = allItems.find((item) => item.item_id === itemId);
          if (!catalogItem) return null;

          const selectedPrice = catalogItem.prices.find(
            (p) => p.size_id === sizeId
          );
          if (!selectedPrice) return null;

          // Fix customization parsing
          let customization = [];
          try {
            if (typeof orderItem.customization === "string") {
              customization = JSON.parse(orderItem.customization);
            } else if (Array.isArray(orderItem.customization)) {
              customization = orderItem.customization;
            }
          } catch (err) {
            console.warn(
              "❌ Error parsing customization",
              orderItem.customization
            );
          }
          //  Include KOT-related fields
          const kot_quatity = parseInt(orderItem.kot_quatity || quantity, 10);
          const kot_quantity_printed = parseInt(
            orderItem.kot_quantity_printed || 0,
            10
          );
          const fullPrinted = !!orderItem.fullPrinted;
          return {
            ...catalogItem,
            prices: [selectedPrice],
            selectedPrice,
            quantity,
            customization,
            kot_quatity,
            kot_quantity_printed,
            fullPrinted,
          };
        })
        .filter(Boolean);
      setCart(formattedItems);
      setSelectedTable(item);
      setSelectedOrder(existingOrder);
      setOrderId(existingOrder.orderid);
      setMobile(existingOrder.customer_mobile?.replace("+91", "").trim());
      setName(existingOrder.customer_name);
      setTotalPrice(existingOrder.totalOrderPrice);

      setSelectedCustomer({
        contact_name: existingOrder.customer_name,
        contact_number: existingOrder.customer_mobile,
      });

      setDueAmount(existingOrder.due_amount);
      setPaidAmount(existingOrder.pay_amount);
      setOrderStatus(existingOrder.payment_status);

      setScreen("Catalog");
    } else {
      console.log("🆕 NEW ORDER FLOW for table", item.tableNo, item);
      generateOrderIDApi(item.whatsappNumber, "dining");
      setSelectedTable(item);
      setScreen("Catalog");
    }
  };

  useEffect(() => {
    console.log("🧠 selectedTable updated to", selectedTable);
  }, [selectedTable]);

  const handleSubmitRoom = ({ item }) => {
    setSelectedRoom(item);
    setShowRoomOrderModal(false);
    openMobilePrompt();
  };

  const handleOrderSelect = (order) => {
    setSelectedOrder(order); // stores full order
    setOrderId(order.orderid); // sets order ID
    setMobile(order.customer_mobile); // sets mobile number
    setName(order.customer_name); // sets name

    setTotalPrice(order.totalOrderPrice);
    setSelectedCustomer({
      contact_name: order.customer_name,
      contact_number: order.customer_mobile,
    });
  };

  const handleUpdateCustomerDetails = async () => {
    const { contact_name, billingName, billingGst, address, orderID } =
      editingDetails;

    // Use fallback values from selectedOrder if field is empty
    const payload = {
      userid: userID,
      custMobile:
        selectedCustomer?.contact_number || selectedOrder.customer_mobile || "",
      custName: contact_name?.trim() || selectedOrder.customer_name || "",
      billingName: billingName?.trim() || selectedOrder.billingName || "",
      billingGst: billingGst?.trim() || selectedOrder.billingGst || "",
      address: address?.trim() || selectedOrder.customer_address || "",
      orderId: orderID || selectedOrder.orderid || "",
    };

    try {
      setSaving(true);
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/updateCustomerName`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setEditCustomer(false);
        getOrdersApi();
      } else {
        alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      console.error("API error:", error);
      alert("Failed to update customer");
    } finally {
      setSaving(false);
    }
  };

  const handlePrintNode = async (
    item,
    business_name,
    gst,
    address,
    phone_no,
    custfullAddress,
    normalFontSize,
    largeFontSize,
    pageWidth
  ) => {
    try {
      console.log("Sending order details:", JSON.stringify(item, null, 2));

      const cleanCustomerAddress = (custfullAddress ?? "")
        .toString()
        .replace(/\s*\n\s*/g, ", ")
        .replace(/,\s*,+/g, ", ")
        .replace(/\s{2,}/g, " ")
        .trim();

      const response = await fetch("http://localhost:3001/printReceipt", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          item,
          business_name,
          gst,
          address,
          phone_no,
          cleanCustomerAddress,
          printSettings: {
            normalFontSize,
            largeFontSize,
            pageWidth,
          },
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message);
      } else {
        toast.error("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Direct print setup incomplete.");
    }
  };

  function formatDateTime(dateStr) {
    // Example input: "19/08/2025 09:47:05 AM"
    const [datePart, timePart, ampm] = dateStr.split(" "); // ["19/08/2025", "09:47:05", "AM"]

    const [day, month, year] = datePart.split("/"); // ["19","08","2025"]
    let [hour, minute] = timePart.split(":"); // ["09","47"]

    hour = parseInt(hour, 10);
    if (ampm === "PM" && hour !== 12) hour += 12;
    if (ampm === "AM" && hour === 12) hour = 0;

    // final format DD/MM/YYYY HH:mm
    return `${day}/${month}/${year} ${hour
      .toString()
      .padStart(2, "0")}:${minute}`;
  }

  const assignDeliveryPartnerApi = async (orderId) => {
    try {
      const payload = {
        userid: userID,
        orderId: orderId,
        platform: "pos",
        deliveryPartner: "packky",
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/assignDeliveryPartner`,
        payload,
        config
      );
      if (response.data.responseCode === "00") {
      } else {
        console.log("Error");
      }
    } catch {
      console.log("Error");
    }
  };
  // ✅ Notify Driver Modal
  const [showNotifyDriverModal, setShowNotifyDriverModal] = useState(false);
  const [notifyOrder, setNotifyOrder] = useState(null);
  const [notifyLoading, setNotifyLoading] = useState(false);

  const openNotifyDriverModal = (order) => {
    setNotifyOrder(order);
    setShowNotifyDriverModal(true);
  };

  const closeNotifyDriverModal = () => {
    setShowNotifyDriverModal(false);
    setNotifyOrder(null);
    setNotifyLoading(false);
  };

  const notifyDriverApi = async () => {
    if (!notifyOrder?.orderid || !userID) {
      toast.error("Order/User info missing.");
      return;
    }

    const payload = {
      userid: userID,
      orderId: String(notifyOrder.orderid),
      orderStatus: "food is ready",      // static
      deliveryPartner: "packky",         // default
    };

    try {
      setNotifyLoading(true);

      // ⚠️ Intentionally NOT passing `config` to avoid CORS/preflight due to Authorization headers.
      const { data } = await axios.post(
        "https://payinnew.remittpe.com/api/Delivery/v1.0/notifyDriver",
        payload,
        config
      );

      // If API returns responseCode pattern, respect it; else treat 200 as success
      if (data?.responseCode && data.responseCode !== "00") {
        toast.error(data?.responseMessage || "Failed to notify driver.");
        return;
      }

      toast.success(data?.responseMessage || "Driver notified successfully.");
      closeNotifyDriverModal();
    } catch (err) {
      console.error("notifyDriver error:", err);
      toast.error("Failed to notify driver.");
    } finally {
      setNotifyLoading(false);
    }
  };

  return (
    <>
      <div className="col-12 row m-0 p-0">
        <ToastContainer />
        <div className="col-10 p-0 m-0">
          <div className="d-flex flex-column h-100">
            {/* Header */}
            <div className="row col-12 m-0 p-0">
              {/* Filter Controls */}
              <div className="row col-12 m-0 p-0">
                {/* Payment Filter */}
                <div className="col-6 p-2 border border-dark">
                  <p className={tabletMode ? "tablet-font-1 text-center mb-2 fw-bold" : "text-center fw-bold mb-2"}>FILTER BY PAYMENT STATUS</p>
                  <div className="row">
                    <div className="col-4 mb-2">
                      <button
                        type="button"
                        onClick={() => setSelectedPaymentFilter("open")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedPaymentFilter === "open"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        OPEN
                      </button>
                    </div>
                    <div className="col-4 mb-2">
                      <button
                        type="button"
                        onClick={() => setSelectedPaymentFilter("paid")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedPaymentFilter === "paid"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        PAID
                      </button>
                    </div>
                    <div className="col-4">
                      <button
                        type="button"
                        onClick={() => setSelectedPaymentFilter("completed")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedPaymentFilter === "completed"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        COMPLETED
                      </button>
                    </div>
                  </div>
                </div>

                {/* Order Type Filter */}
                <div className="col-6 p-2 border border-dark">
                  <p className={tabletMode ? "tablet-font-1 text-center mb-2 fw-bold" : "text-center fw-bold mb-2"}>FILTER BY ORDER TYPE</p>
                  <div className="row">
                    <div className="col-3 mb-2">
                      <button
                        type="button"
                        onClick={() => setSelectedOrderTypeFilter("all")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedOrderTypeFilter === "all"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        ALL
                      </button>
                    </div>
                    <div className="col-3 mb-2">
                      <button
                        type="button"
                        onClick={() => setSelectedOrderTypeFilter("dining")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedOrderTypeFilter === "dining"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        DINE-IN
                      </button>
                    </div>
                    <div className="col-3 mb-2">
                      <button
                        type="button"
                        onClick={() => setSelectedOrderTypeFilter("takeaway")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedOrderTypeFilter === "takeaway"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        TAKEAWAY
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        type="button"
                        onClick={() => setSelectedOrderTypeFilter("homedelivery")}
                        className={`filter-btn ${tabletMode ? "tablet-btn" : ""
                          } ${selectedOrderTypeFilter === "homedelivery"
                            ? "bg-green-order text-white"
                            : "bg-white text-dark"}`}
                      >
                        HOME DELIVERY
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Content Area */}
            <div
              className={`flex-grow-1 overflow-auto d-flex justify-content-center align-items-top ${tabletMode ? "tablet-mode" : ""
                } orders-container`}
            >
              <div className="table-responsive mt-3 w-100">
                <table className="table table-hover table-border border-dark table-bordered align-middle text-center orders-table">
                  <thead>
                    <tr>
                      <th>ODR ID</th>
                      <th>BILL NO</th>
                      <th>DATE</th>
                      <th>NAME</th>
                      <th>MOBILE</th>
                      <th>TYPE</th>
                      <th>TBL</th>
                      <th>AMOUNT</th>
                      <th>PAID</th>
                      <th>DUE</th>
                      <th>DELIVERY</th>

                    </tr>
                  </thead>
                  <tbody>
                    {filteredOrders.length > 0 ? (
                      filteredOrders.map((order) => (
                        <tr
                          key={order.id}
                          className={`table-row-hover cursor-pointer ${selectedOrder.orderid === order.orderid
                            ? "bg-green-order text-white"
                            : ""
                            }`}
                          onClick={() => {
                            if (selectedOrder?.orderid === order.orderid) {
                              setSelectedOrder({});
                            } else {
                              setSelectedOrder(order);
                            }
                          }}
                          onDoubleClick={() => {
                            handleOrderSelect(order);
                            openViewPrompt();
                          }}
                        >
                          <td>{order.daily_order_id || "HOLD"}</td>
                          <td>{order.orderid}</td>
                          <td>{formatDateTime(order.order_date)}</td>
                          <td>{order.customer_name || "N/A"}</td>
                          <td>{order.customer_mobile}</td>
                          <td>{order.orderType?.toUpperCase()}</td>
                          <td>
                            {["dining", "room_order"].includes(order.orderType)
                              ? order.table_no || "N/A"
                              : ""}
                          </td>

                          <td>{Number(order.totalOrderPrice).toFixed(0)}</td>
                          <td>{Number(order.pay_amount).toFixed(0)}</td>
                          <td>
                            <span
                              className={`badge ${order.payment_status === "paid"
                                ? "bg-success"
                                : "bg-danger"
                                }`}
                            >
                              {Number(order.due_amount).toFixed(0)}
                            </span>
                          </td>
                          <td>
                            {order.orderType === "homedelivery" ? (
                              String(order.delivery_partner_status || "").toLowerCase() === "acknowledged" ? (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-warning fw-bold"
                                  onClick={(e) => {
                                    e.stopPropagation(); // ✅ prevent row select toggle
                                    openNotifyDriverModal(order);
                                  }}
                                >
                                  ACKNOWLEDGED
                                </button>
                              ) : (
                                order.delivery_partner_status?.toUpperCase() || "NA"
                              )
                            ) : (
                              "N/A"
                            )}
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center text-muted py-5">
                          {posOrderLoader ? (
                            <>
                              <div
                                className="spinner-border text-secondary mt-2"
                                role="status"
                              >
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <div className="mt-3 fs-5 fw-medium">Loading orders...</div>
                            </>
                          ) : (
                            <div className="mt-3 fs-5 fw-medium">
                              No orders match the selected filters.
                            </div>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Action Buttons */}
            <div className={`row col-12 m-0 p-0 ${tabletMode ? "tablet-mode" : ""}`}>
              <div className="col-12">
                <div className="row">
                  <div className="col-4 mb-2">
                    <button
                      type="button"
                      onClick={() => setShowViewModal(true)}
                      className="scale-button shadow border border-secondary rounded d-flex justify-content-center align-items-center orders-action-btn"
                    >
                      VIEW
                    </button>
                  </div>
                  <div className="col-4 mb-2">
                    <button
                      type="button"
                      disabled={
                        selectedOrder.status !== "hold" ||
                        selectedOrder.payment_status === "partially_paid"
                      }
                      onClick={() => onOpenClick(selectedOrder)}
                      className="scale-button shadow border border-secondary rounded d-flex justify-content-center align-items-center orders-action-btn"
                    >
                      EDIT
                    </button>
                  </div>
                  <div className="col-4">
                    <button
                      type="button"
                      disabled={selectedOrder.status !== "hold"}
                      onClick={() => onSettleClick(selectedOrder)}
                      className="scale-button shadow border border-secondary rounded d-flex justify-content-center align-items-center orders-action-btn"
                    >
                      SETTLE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-2 p-2 m-0 border-start border-dark">
          <div className="p-2">
            <button
              className={`new-order-btn new-order-btn-base ${tabletMode ? "tablet-new-order-btn" : ""
                }`}
              onClick={() => {
                clearAllForNewOrder();
                setOrderType("dining");
                openTablePrompt();
              }}
            >
              DINE IN
            </button>
          </div>

          <div className="p-2">
            <button
              className={`new-order-btn new-order-btn-base ${tabletMode ? "tablet-new-order-btn" : ""
                }`}
              onClick={() => {
                clearAllForNewOrder();
                setOrderType("takeaway");
                openMobilePrompt();
              }}
            >
              TAKEAWAY
            </button>
          </div>

          <div className="p-2">
            <button
              className={`new-order-btn new-order-btn-base ${tabletMode ? "tablet-new-order-btn" : ""
                }`}
              onClick={() => {
                clearAllForNewOrder();
                setOrderType("homedelivery");
                openMobilePrompt();
              }}
            >
              HOME DELIVERY
            </button>
          </div>

          <div className="p-2">
            {userID === "A1031" || userID === "A1189" ? (
              <button
                className={`new-order-btn new-order-btn-base ${tabletMode ? "tablet-new-order-btn" : ""
                  }`}
                onClick={() => {
                  clearAllForNewOrder();
                  setOrderType("room_order");
                  openRoomOrderPrompt();
                }}
              >
                ROOM ORDER
              </button>
            ) : (
              <div className="m-2 rounded bg-transparent new-order-btn" />
            )}
          </div>
        </div>

      </div>
      {/* Mobile Number Modal */}
      {showMobileModal && (
        <div className={tabletMode ? "tablet-mode" : ""}>
          {/* Overlay */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100 mobile-modal-overlay"
            style={{ backgroundColor: "#00000088", zIndex: 1040 }}
            onClick={() => setShowMobileModal(false)}
          />

          {/* Modal Container */}
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white border shadow p-4 rounded mobile-modal-container"
            style={{ width: "1200px", zIndex: 1050 }}
          >
            <div className="row col-12 p-0 m-0">
              <div className="col-5">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="fw-bold mb-0">Enter Mobile Number</h4>
                  {orderType === "takeaway" && (
                    <button
                      className="scale-button btn btn-warning fs-5 fw-bold border border-dark px-4 py-2"
                      tabIndex={-1}
                      onClick={handleDefaultSubmit}
                    >
                      Default
                    </button>
                  )}
                </div>

                <input
                  type="text"
                  inputMode="numeric"
                  className="form-control shadow form-control-lg text-center fw-bold mb-3 p-3 border border-dark"
                  value={mobile}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 12) setMobile(value);
                  }}
                  placeholder="10-digit mobile"
                  autoFocus
                />

                <div className="row mb-3">
                  {keypadFull.map((row, i) => (
                    <div className="row w-100 m-0 p-0" key={i}>
                      {row.map((key) => (
                        <div className="col-4" key={key}>
                          <button
                            type="button"
                            tabIndex={-1}
                            onClick={() => handleKeyClick(key)}
                            style={{ height: "80px", width: "100%" }}
                            className="scale-button shadow border my-3 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-5 fw-bold mobile-keypad-btn"
                          >
                            {key}
                          </button>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-between align-items-center gap-3">
                  <button
                    className="scale-button btn btn-light fs-4 fw-bold border border-dark mobile-action-btn"
                    style={{ height: "80px", width: "25%" }}
                    tabIndex={-1}
                    onClick={() => setShowMobileModal(false)}
                  >
                    Back
                  </button>

                  <button
                    type="button"
                    onClick={handleSubmitMobile}
                    disabled={
                      !(
                        orderType === "dining" ||
                        orderType === "room_order" ||
                        mobile.length === 10 ||
                        mobile.length === 12
                      )
                    }
                    style={{ height: "80px", width: "75%" }}
                    className="scale-button shadow border border-dark btn btn-success bg-green-order rounded d-flex justify-content-center align-items-center fs-4 fw-bold mobile-action-btn"
                  >
                    Continue
                  </button>
                </div>
              </div>

              <div className="col-7">
                <div
                  className="border rounded p-3 bg-light "
                  style={{ height: "700px", overflowY: "auto" }}
                >
                  {customerList.length === 0 && mobile ? (
                    <div className="text-center text-muted fs-5 mt-5">
                      {orderType === "homedelivery" ? (
                        <div
                          className="container py-4 px-3"
                          style={{ maxWidth: 540 }}
                        >
                          {searchCustomerLoader ? (
                            <>
                              <div
                                className="spinner-border text-secondary mt-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              <div className="mt-3 fs-5 fw-medium">
                                Loading Customer...
                              </div>
                            </>
                          ) : (
                            <div className="mt-3 fs-5 fw-medium">
                              No customer found.
                            </div>
                          )}
                          <h3 className="mb-4 text-dark fw-semibold">
                            {" "}
                            Add New Customer
                          </h3>

                          {formErrors.api && (
                            <div className="alert alert-danger py-2 px-3 mb-3 rounded">
                              {formErrors.api}
                            </div>
                          )}

                          {formErrorsOrder.map((key) =>
                            formErrors[key] ? (
                              <div
                                key={key}
                                className="alert alert-danger py-2 px-3 mb-3 rounded"
                              >
                                {formErrors[key]}
                              </div>
                            ) : null
                          )}

                          <div className="row g-3">
                            <div className="col-12">
                              <input
                                type="text"
                                className="form-control p-3 shadow-sm"
                                placeholder="Full Name *"
                                value={newAddress.name}
                                onChange={(e) =>
                                  handleInputChange("name", e.target.value)
                                }
                              />
                            </div>

                            <div className="col-12">
                              <input
                                type="text"
                                className="form-control p-3 shadow-sm"
                                placeholder="Address *"
                                value={newAddress.address}
                                onChange={(e) =>
                                  handleInputChange("address", e.target.value)
                                }
                              />
                            </div>

                            <div className="col-12">
                              <input
                                type="text"
                                className="form-control p-3 shadow-sm"
                                placeholder="City *"
                                value={newAddress.city}
                                onChange={(e) =>
                                  handleInputChange("city", e.target.value)
                                }
                              />
                            </div>
                          </div>

                          <div className="d-flex justify-content-start mt-4">
                            <button
                              className="scale-button btn btn-success px-4 py-2 rounded-pill shadow-sm"
                              onClick={() =>
                                handleAddNewAddress({
                                  contact_name: newAddress.name,
                                  contact_number: mobile,
                                })
                              }
                            >
                              Save Address
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          {searchCustomerLoader ? (
                            <>
                              <div
                                className="spinner-border text-secondary mt-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              <div className="mt-3 fs-5 fw-medium">
                                Loading Customer...
                              </div>
                            </>
                          ) : (
                            <div className="mt-3 fs-5 fw-medium">
                              No customer found.
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    customerList.map((item, index) => (
                      <div
                        key={item.id}
                        onClick={() => setSelectedCustomer(item)}
                        className={` w-100 p-3 my-2 cursor-pointer  
            ${item.id === selectedCustomer?.id
                            ? "card text-dark border border-success "
                            : "bg-light border  rounded"
                          }`}
                        style={{ transition: "0.3s ease", cursor: "pointer" }}
                      >
                        <div className="fs-5 fw-semibold d-flex justify-content-between align-items-center">
                          <span>
                            {item.contact_name} | {item.contact_number}
                          </span>
                          {orderType === "homedelivery" && (
                            <button
                              className="scale-button btn bg-green-order text-white single-line-css"
                              onClick={() => setShowAddressFormFor(item)}
                            >
                              Add Address
                            </button>
                          )}
                        </div>
                        {showAddressFormFor?.id === item.id && (
                          <div className="text-start my-3">
                            <h6 className="mb-3 text-dark">
                              Add Another Address for {item.name}
                            </h6>

                            {formErrors.api && (
                              <div className="alert alert-danger">
                                {formErrors.api}
                              </div>
                            )}
                            {formErrorsOrder.find((k) => formErrors[k]) &&
                              !formErrors.api && (
                                <div className="alert alert-warning">
                                  {
                                    formErrors[
                                    formErrorsOrder.find((k) => formErrors[k])
                                    ]
                                  }
                                </div>
                              )}

                            <div className="row g-3">
                              <div className="col-12">
                                <textarea
                                  placeholder="Full Address *"
                                  className="form-control p-3"
                                  rows="2"
                                  value={newAddress.address}
                                  onChange={(e) =>
                                    handleInputChange("address", e.target.value)
                                  }
                                />
                              </div>
                              <div className="col-12">
                                <input
                                  placeholder="Landmark / Area *"
                                  className="form-control p-3"
                                  value={newAddress.landmark_area}
                                  onChange={(e) =>
                                    handleInputChange(
                                      "landmark_area",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                              <div className="col-12">
                                <input
                                  placeholder="City *"
                                  className="form-control p-3"
                                  value={newAddress.city}
                                  onChange={(e) =>
                                    handleInputChange("city", e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <button
                              className="scale-button btn btn-primary mt-4"
                              onClick={() =>
                                handleAddMoreAddress({
                                  contact_name: item.name,
                                  contact_number: item.mobile,
                                })
                              }
                            >
                              Save Address
                            </button>
                          </div>
                        )}

                        {(orderType === "homedelivery" || orderType === "takeaway") && (
                          <>
                            {/* Default Address Display */}
                            <div className="mt-3">
                              <div className="p-3 border rounded bg-light">
                                <span className="badge bg-green-order text-white me-2 fs-5">
                                  Default Address
                                </span>
                                <span className="fs-6 text-dark">
                                  {item.defaultAddress}
                                </span>
                              </div>
                            </div>
                            <hr />
                            {/* Address List */}
                            <div className="fs-6 mt-4">
                              {item.address.map((address, index) => {
                                const isDefault =
                                  address === item.defaultAddress;

                                return (
                                  <div
                                    key={index}
                                    className={`border rounded p-3 mb-3 ${isDefault
                                      ? "bg-success bg-opacity-10 border-success"
                                      : ""
                                      }`}
                                  >
                                    <div className="d-flex justify-content-between align-items-start flex-wrap">
                                      <div className="text-dark w-75">
                                        {address}
                                      </div>

                                      {!isDefault && (
                                        <button
                                          className="scale-button btn btn-sm btn-outline-success"
                                          onClick={() =>
                                            handleDefaultAddress(
                                              item.contact_number,
                                              address
                                            )
                                          }
                                        >
                                          Mark as Default
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>


      )}

      {showTableModal && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ backgroundColor: "#00000088", zIndex: 1040 }}
            onClick={() => setShowTableModal(false)}
          />
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white border shadow p-4 rounded"
            style={{ width: "1000px", zIndex: 1050 }}
          >
            <h1 className="text-center fw-bold mb-4">Select Table</h1>
            {/* {JSON.stringify(selectedTable.tableNo)} */}

            <div className="row col-12 p-0 m-0">
              {enrichedTables.length === 0 ? (
                <div className="text-center w-100 py-5">
                  <h5 className="text-muted">🚫 No dining table added.</h5>
                  <p className="text-muted">
                    To start dining service, please add a table from{" "}
                    <strong>Orders → Dining</strong>.
                  </p>
                </div>
              ) : (
                enrichedTables.map((item) => {
                  const isAvailable =
                    item.status === "Open" && item.reservationStatus === "N";

                  return (
                    <div
                      key={item.id}
                      className="col-6 col-sm-4 col-md-3 col-lg-2 p-3 "
                    >
                      <div
                        // onClick={() => isAvailable && handleSubmitTable({ item })}
                        onClick={() => handleSubmitTable({ item })}
                        className={`card text-center shadow-sm border-0 w-100 cursor-pointer ${isAvailable
                          ? "bg-green-order text-white"
                          : "bg-warning text-dark"
                          }`}
                        style={{
                          transition: "transform 0.2s ease-in-out",
                        }}
                        onMouseEnter={(e) => {
                          if (isAvailable)
                            e.currentTarget.style.transform = "scale(1.03)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <div
                          className="card-body d-flex flex-column justify-content-center align-items-center"
                          style={{ height: "120px" }}
                        >
                          <h1 className="mb-1 fw-bold">{item.tableNo}</h1>
                          <span
                            className={`badge fs-6 mt-2 ${isAvailable
                              ? "bg-white text-success"
                              : "bg-dark text-warning"
                              }`}
                          >
                            {item.reservationStatus === "Y"
                              ? "Reserved"
                              : "Available"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
      {showRoomOrderModal && (
        <>
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ backgroundColor: "#00000088", zIndex: 1040 }}
            onClick={() => setShowRoomOrderModal(false)}
          />
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white border shadow p-4 rounded"
            style={{ width: "1000px", zIndex: 1050 }}
          >
            <h1 className="text-center fw-bold mb-4">Select Room</h1>
            {/* {JSON.stringify(selectedTable.tableNo)} */}

            <div className="row col-12 p-0 m-0">
              {rooms.length === 0 ? (
                <div className="text-center w-100 py-5">
                  <h5 className="text-muted">🚫 No Room added.</h5>
                  <p className="text-muted">
                    To start room order, please add a room from{" "}
                    <strong>Orders → Room</strong>.
                  </p>
                </div>
              ) : (
                rooms.map((item) => {
                  const isAvailable =
                    item.status === "Open" && item.reservationStatus === "N";

                  return (
                    <div
                      key={item.id}
                      className="col-6 col-sm-4 col-md-3 col-lg-2 p-3"
                    >
                      <div
                        onClick={() =>
                          isAvailable && handleSubmitRoom({ item })
                        }
                        className={`card text-center shadow-sm border-0 w-100 ${isAvailable
                          ? "bg-green-order text-white"
                          : "bg-light text-muted"
                          }`}
                        style={{
                          cursor: isAvailable ? "pointer" : "not-allowed",
                          opacity: isAvailable ? 1 : 0.6,
                          transition: "transform 0.2s ease-in-out",
                        }}
                        onMouseEnter={(e) => {
                          if (isAvailable)
                            e.currentTarget.style.transform = "scale(1.03)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <div
                          className="card-body d-flex flex-column justify-content-center align-items-center"
                          style={{ height: "120px" }}
                        >
                          <h1 className="mb-1 fw-bold">{item.roomNumber}</h1>
                          <span
                            className={`badge fs-6 mt-2 ${isAvailable ? "bg-white text-success" : ""
                              }`}
                          >
                            {item.reservationStatus === "Y"
                              ? "Ongoing"
                              : "Take Order"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
      {showViewModal && (
        <div className={tabletMode ? "tablet-mode view-modal-container" : ""}>
          <div
            className={tabletMode ? "position-fixed top-0 start-0 w-100 h-100" : "position-fixed top-0 start-0 w-100 h-100"}
            style={{ backgroundColor: "#00000088", zIndex: 1040 }}
            onClick={() => {
              setShowViewModal(false);
              setBillNumber("");
              setParticularOrderDetails({});
              setSelectedOrder({});
            }}
          />
          <div
            className={tabletMode ? "position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-2 rounded-4 " : "position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-5 rounded-4 fs-5"}
            style={{ width: "1000px", zIndex: 1050, fontFamily: "monospace" }}
          >
            {/* {JSON.stringify(particularOrderDetails)} */}
            {/* ✅ Case 1: No order selected → show input/search */}
            {(!selectedOrder || Object.keys(selectedOrder).length === 0) &&
              (!particularOrderDetails ||
                Object.keys(particularOrderDetails).length === 0) && (
                <div
                  className="text-center p-4"
                  style={{ background: "#f8f9fa", borderRadius: "12px" }}
                >
                  <h3
                    className="mb-4 fw-bold text-dark"
                    style={{ fontSize: "1.8rem" }}
                  >
                    Search Order by Bill Number
                  </h3>

                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <input
                      type="number" // only allows numbers
                      placeholder="Enter Bill Number"
                      value={billNumber}
                      onChange={(e) =>
                        setBillNumber(e.target.value.replace(/\D/g, ""))
                      } // removes non-numeric
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && billNumber.trim()) {
                          orderDetailesAPI(billNumber);
                        }
                      }}
                      autoFocus
                      className="form-control fw-bold text-center shadow-sm"
                      style={{
                        maxWidth: "280px",
                        fontSize: "1.3rem",
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "2px solid #343a40",
                      }}
                    />

                    <button
                      type="button"
                      disabled={!billNumber.trim()}
                      onClick={() => {
                        orderDetailesAPI(billNumber);
                      }}
                      className="btn fw-bold shadow bg-green-filter"
                      style={{
                        color: "#fff",
                        fontSize: "1.2rem",
                        padding: "12px 24px",
                        borderRadius: "10px",
                        border: "none",
                      }}
                    >
                      {billLoader ? "Searching.." : "Search"}
                    </button>
                  </div>
                </div>
              )}

            {(selectedOrder && Object.keys(selectedOrder).length > 0) ||
              (particularOrderDetails &&
                Object.keys(particularOrderDetails).length > 0) ? (
              <>
                <div
                  className="position-fixed top-0 start-0 w-100 h-100"
                  style={{ backgroundColor: "#00000088", zIndex: 1040 }}
                  onClick={() => setShowViewModal(false)}
                />
                <div
                  className="position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-5 rounded-4 fs-5"
                  style={{
                    width: "1000px",
                    zIndex: 1050,
                    fontFamily: "monospace",
                  }}
                >
                  <div className="row col-12 ">
                    <div className={tabletMode ? "col-8 p-3  rounded tablet-font-1" : "col-8 p-4 rounded"}>


                      <div className="text-center mb-4">
                        <h2 className="fw-bold">
                          Order Details #{selectedOrder.orderid}
                        </h2>
                        <p>{selectedOrder.order_date}</p>
                        <hr />
                      </div>
                      {selectedOrder.orderType === "homedelivery" && (
                        <div className="card border-0 shadow-sm mb-3 w-100">
                          <div className="card-header bg-warning text-dark fw-semibold py-2 px-3 ">
                            Delivery Status:{" "}
                            <span className="text-uppercase">
                              {selectedOrder.delivery_partner_status || "N/A"}
                            </span>
                          </div>
                          <div className="card-body bg-warning bg-opacity-10 py-2 px-3">
                            <div className="row">
                              <div className="">
                                <span className="fw-bold">Delivery Person:</span>{" "}
                                <span className="text-dark">{selectedOrder.delivery_person_name || "N/A"}{" "}| {" "}{selectedOrder.delivery_person_number || "N/A"}</span>
                              </div>

                            </div>
                          </div>
                        </div>
                      )}
                      <div className="d-flex justify-content-between w-100">

                        <div>
                          <div className="mb-3">
                            <strong>Customer:</strong>{" "}
                            {selectedOrder.customer_name}
                            <br />
                            <strong>Phone:</strong>{" "}
                            {selectedOrder.customer_mobile}
                            <br />
                            {selectedOrder.billingName ? (
                              <>
                                <strong>Billing Name:</strong>{" "}
                                {selectedOrder.billingName}
                              </>
                            ) : (
                              ""
                            )}
                            {selectedOrder.billingGst ? (
                              <>
                                <strong>Billing GST:</strong>{" "}
                                {selectedOrder.billingGst}
                              </>
                            ) : (
                              ""
                            )}
                            {selectedOrder.billingAddress ? (
                              <>
                                <strong>Billing Address:</strong>{" "}
                                {selectedOrder.billingAddress}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div>
                          {" "}
                          <button
                            className="scale-button btn btn-outline-dark fw-bold px-4 py-2 ms-3 rounded-3"
                            onClick={() => {
                              setEditingDetails({
                                contact_name: selectedOrder.customer_name || "",
                                billingName: selectedOrder.billingName || "",
                                address: selectedOrder.customer_address || "",
                                orderID: selectedOrder.orderid || "",
                              });
                              setEditCustomer(true);
                              setShowViewModal(false);
                            }}
                          >
                            Edit Customer
                          </button>
                        </div>
                      </div>

                      <div className="table-responsive mb-5">
                        <table className="table table-bordered text-center align-middle shadow-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Item Name</th>
                              <th>Qty</th>
                              <th>Unit Price (₹)</th>
                              <th>Total (₹)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedOrder.items.map((item, index) => {
                              const price = parseFloat(item.item_price || "0");
                              const quantity = parseInt(
                                item.quantity || "1",
                                10
                              );
                              const total = price * quantity;

                              // ✅ Parse customization string from API
                              let customizationText = "";
                              try {
                                const parsed = JSON.parse(
                                  item.customization || "[]"
                                );
                                customizationText = parsed
                                  .flatMap((c) =>
                                    Array.isArray(c.options)
                                      ? c.options
                                      : [c.options]
                                  )
                                  .join(", ");
                              } catch (err) {
                                console.warn(
                                  "Failed to parse customization",
                                  item.customization
                                );
                              }

                              return (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td className="text-start">
                                    {item.item_name}
                                    {item.sizeWords
                                      ? ` (${item.sizeWords})`
                                      : ""}
                                    {customizationText && (
                                      <div
                                        className="text-muted"
                                        style={{
                                          fontSize: "0.85rem",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {customizationText}
                                      </div>
                                    )}
                                  </td>
                                  <td>{quantity}</td>
                                  <td>₹{price.toFixed(2)}</td>
                                  <td>₹{total.toFixed(2)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>Subtotal:</span>
                        <span>
                          ₹ {parseFloat(selectedOrder.subtotal).toFixed(2)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <span>Discount Amount:</span>
                        <span>
                          ₹{" "}
                          {parseFloat(selectedOrder.discount_amount).toFixed(2)}
                        </span>
                      </div>
                      {Number(sgst) > 0 && Number(cgst) > 0 && (
                        <>
                          <div className="d-flex justify-content-between ">
                            <span>CGST:</span>
                            <span>
                              ₹{parseFloat(selectedOrder.tax_cgst).toFixed(2)}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span>SGST:</span>
                            <span>
                              ₹{parseFloat(selectedOrder.tax_sgst).toFixed(2)}
                            </span>
                          </div>
                        </>
                      )}
                      <div className="d-flex justify-content-between">
                        <span>Other Charges:</span>
                        <span>
                          ₹ {parseFloat(selectedOrder.charges).toFixed(2)}
                        </span>
                      </div>
                      <hr />
                      <div className="d-flex justify-content-between fw-bold fs-5">
                        <span>Total:</span>
                        <span>
                          ₹{" "}
                          {parseFloat(selectedOrder.totalOrderPrice).toFixed(2)}
                        </span>
                      </div>

                      <div className="text-end mt-4 fs-4">
                        <div className="text-dark fw-bold ">
                          Payment Status:{" "}
                          {selectedOrder.payment_status?.toUpperCase()}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ borderLeft: "3px dashed #000" }}
                      className="col-4 d-flex justify-content-center flex-column align-items-center"
                    >
                      <div className="mb-2 w-100">
                        <button
                          type="button"
                          disabled={
                            selectedOrder.status !== "hold" ||
                            selectedOrder.payment_status === "partially_paid"
                          }
                          onClick={() => onOpenClick(selectedOrder)}
                          style={{ height: "120px", width: "250px" }}
                          className={
                            tabletMode
                              ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
                              : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                          }
                        >
                          EDIT
                        </button>
                      </div>
                      <div className="w-100">
                        <button
                          type="button"
                          disabled={selectedOrder.status !== "hold"}
                          onClick={() => onSettleClick(selectedOrder)}
                          style={{ height: "120px", width: "250px" }}
                          className={
                            tabletMode
                              ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
                              : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                          }
                        >
                          SETTLE
                        </button>
                      </div>

                      <div className="w-100">
                        <button
                          type="button"
                          onClick={() =>
                            handlePrintNode(
                              selectedOrder,
                              reciptDetails.business_name,
                              reciptDetails.gst,
                              reciptDetails.address,
                              reciptDetails.phone_no,

                              selectedOrder.address_line,
                              printConfig.normalFontSize,
                              printConfig.largeFontSize,
                              printConfig.pageWidth
                            )
                          }
                          style={{ height: "120px", width: "250px" }}
                          className={
                            tabletMode
                              ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
                              : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                          }
                        >
                          DIRECT PRINT
                        </button>
                      </div>


                      <div className="w-100">
                       
                        <POSPrint
                          tabletMode={tabletMode}
                          cart={selectedOrder.items}
                          reciptDetails={reciptDetails}
                          totalPrice={selectedOrder.totalOrderPrice}
                          mobile={mobile}
                          orderType={orderType}
                          orderId={orderId}
                          tenderedAmount={selectedOrder.tenderedAmount}
                          selectedDiscount={selectedOrder.selectedDiscount}
                          apiResponsePrint={selectedOrder}
                          gstClaim={gstClaim}
                          sgst={sgst}
                          cgst={cgst}
                        />
                      </div>
                      {selectedOrder.orderType === "homedelivery" && (
                        <div className="p-2">
                          <button
                            onClick={() => {
                              assignDeliveryPartnerApi(orderId);
                            }}
                            style={{ height: "120px", width: "250px" }}
                            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-4 fw-bold"
                          >
                            ASSIGN TO PACKKY
                          </button>
                        </div>
                      )}
                      <div className="w-100">
                        <button
                          type="button"
                          disabled={selectedOrder.status !== "hold"}
                          onClick={() => {
                            setShowCancelReasonModal(true);
                            setShowViewModal(false);
                          }}
                          style={{ height: "120px", width: "250px" }}
                          className={
                            tabletMode
                              ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
                              : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                          }
                        >
                          ORDER CANCEL
                        </button>
                      </div>
                      <div className="w-100">
                        <button
                          type="button"
                          onClick={() => {
                            setShowViewModal(false);
                            setBillNumber("");
                            setParticularOrderDetails({});
                            setSelectedOrder({});
                          }}
                          style={{ height: "120px", width: "250px" }}
                          className={
                            tabletMode
                              ? "vm-tablet-button scale-button shadow border border-secondary cursor-pointer rounded d-flex justify-content-center align-items-center"
                              : "scale-button shadow border border-secondary m-2 cursor-pointer rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
                          }
                        >
                          CLOSE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}

      {showCancelReasonModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "#00000088", zIndex: 1060 }}
        >
          <div
            className="bg-white p-4 rounded shadow-lg"
            style={{ width: "400px" }}
          >
            <h4 className="mb-3">Select Cancellation Reason</h4>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="radio"
                name="cancelReason"
                id="cancelByRestaurant"
                value="restaurant"
                onChange={(e) => setCancelOrderReason(e.target.value)}
              />
              <label className="form-check-label" htmlFor="cancelByRestaurant">
                Cancelled by Restaurant
              </label>
            </div>
            <div className="form-check mb-4">
              <input
                className="form-check-input"
                type="radio"
                name="cancelReason"
                id="cancelByCustomer"
                value="customer"
                onChange={(e) => setCancelOrderReason(e.target.value)}
              />
              <label className="form-check-label" htmlFor="cancelByCustomer">
                Cancelled by Customer
              </label>
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="scale-button btn btn-secondary me-2"
                onClick={() => setShowCancelReasonModal(false)}
              >
                Close
              </button>
              <button
                className="scale-button btn btn-danger"
                disabled={!cancelOrderReason}
                onClick={() => {
                  cancelPOSOrderApi(orderId, cancelOrderReason);
                  setShowCancelReasonModal(false);
                }}
              >
                Confirm Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {editCustomer && (
        <>
          {/* Backdrop */}
          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ backgroundColor: "#00000088", zIndex: 1040 }}
          />

          {/* Main Modal Container */}
          <div
            className="position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-5 rounded-4 fs-5"
            style={{
              width: "1000px",
              zIndex: 1050,
              fontFamily: "monospace",
            }}
          >
            <div className="row col-12 g-4">
              {/* Left Side: Form */}
              <div className="col-8 p-4 shadow rounded border">
                <h4 className="text-center fw-bold mb-4">
                  Edit Customer Details
                </h4>

                {/* Name Field */}
                <div className="mb-3">
                  <label className="form-label">Customer Name</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={editingDetails.contact_name}
                    onChange={(e) =>
                      setEditingDetails({
                        ...editingDetails,
                        contact_name: e.target.value,
                      })
                    }
                    placeholder="Enter Customer Full Name"
                    autoFocus
                  />
                </div>

                {/* Billing Name */}
                <div className="mb-3">
                  <label className="form-label">Billing Name</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={editingDetails.billingName}
                    onChange={(e) =>
                      setEditingDetails({
                        ...editingDetails,
                        billingName: e.target.value,
                      })
                    }
                    placeholder="Billing Name (Optional)"
                  />
                </div>
                {/* Billing Name */}
                <div className="mb-3">
                  <label className="form-label">Billing GST</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    value={editingDetails.billingGst}
                    onChange={(e) =>
                      setEditingDetails({
                        ...editingDetails,
                        billingGst: e.target.value,
                      })
                    }
                    placeholder="Billing GST (Optional)"
                  />
                </div>
                {/* Address */}
                <div className="mb-3">
                  <label className="form-label">Billing Address</label>
                  <textarea
                    className="form-control form-control-lg"
                    value={editingDetails.address}
                    onChange={(e) =>
                      setEditingDetails({
                        ...editingDetails,
                        address: e.target.value,
                      })
                    }
                    placeholder="Full Address"
                    rows="3"
                  />
                </div>
              </div>

              {/* Right Side: Action Panel */}
              <div
                className="col-4 d-flex flex-column align-items-center justify-content-center"
                style={{ borderLeft: "3px dashed #000" }}
              >
                <button
                  type="button"
                  onClick={() => handleUpdateCustomerDetails()}
                  disabled={saving}
                  style={{
                    height: "120px",
                    width: "250px",
                    fontSize: "1.5rem",
                  }}
                  className="scale-button shadow border border-secondary m-2 rounded bg-light d-flex justify-content-center align-items-center fw-bold"
                >
                  {saving ? "Saving..." : "SAVE"}
                </button>
                <button
                  type="button"
                  onClick={() => setEditCustomer(false)}
                  style={{
                    height: "120px",
                    width: "250px",
                    fontSize: "1.5rem",
                  }}
                  className="scale-button shadow border border-secondary m-2 rounded bg-light d-flex justify-content-center align-items-center fw-bold"
                >
                  CLOSE
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {showNotifyDriverModal && (
  <div className={tabletMode ? "tablet-mode" : ""}>
    {/* Overlay */}
    <div
      className="position-fixed top-0 start-0 w-100 h-100"
      style={{ backgroundColor: "#00000088", zIndex: 1040 }}
      onClick={closeNotifyDriverModal}
    />

    {/* Modal */}
    <div
      className="position-fixed top-50 start-50 translate-middle bg-white border shadow-lg p-4 rounded-4"
      style={{ width: "520px", zIndex: 1050 }}
      onClick={(e) => e.stopPropagation()}
    >
      <h4 className="fw-bold mb-3">Notify Driver</h4>

      <div className="mb-2">
        <div className="text-muted small">Order ID</div>
        <div className="fw-bold">{notifyOrder?.orderid || "N/A"}</div>
      </div>

      <div className="mb-2">
        <div className="text-muted small">Delivery Partner</div>
        <div className="fw-bold">Packky</div>
      </div>

      <div className="mb-2">
        <div className="text-muted small">Order Status</div>
        <div className="fw-bold">Food is ready</div>
      </div>

      <hr />

      <div className="mb-2">
        <div className="text-muted small">Driver Name</div>
        <div className="fw-bold">{notifyOrder?.delivery_person_name || "N/A"}</div>
      </div>

      <div className="mb-3">
        <div className="text-muted small">Driver Number</div>
        <div className="fw-bold">{notifyOrder?.delivery_person_number || "N/A"}</div>
      </div>

      <div className="d-flex gap-2 justify-content-end">
        <button
          type="button"
          className="btn btn-light fw-bold"
          onClick={closeNotifyDriverModal}
          disabled={notifyLoading}
        >
          Close
        </button>

        <button
          type="button"
          className="btn btn-success fw-bold"
          onClick={notifyDriverApi}
          disabled={notifyLoading}
        >
          {notifyLoading ? "Notifying..." : "Food Is Ready"}
        </button>
      </div>
    </div>
  </div>
)}

    </>
  );
};

export default POSOrderType;
